
export enum PayMethod{
  alipay = 'alipay',
  wechat = 'wechat'
}
